import * as React from 'react';
import { observer } from 'mobx-react';
import { ErrorMessage } from '../components/error-message/error-message';
import { PanelContentTransition } from '../../WebGiving/components/panel-content-transition';
import { getPageClasses } from './helpers/get-page-classes';
import { PayerOnboardingUserAction } from '../payer-onboarding-user-actions';
import { IPayerOnboardingPageViewModel } from './payer-onboarding-page-view-model';
import { ResetPageReason } from '../payer-onboarding-generated';

@observer
export class PageError extends React.Component<{
	vm: IPayerOnboardingPageViewModel,
	raiseAction: (action: PayerOnboardingUserAction) => void,
	transitionState: string,
}> {
	panelBodyNode: HTMLDivElement;

	render() {
		const { vm, transitionState } = this.props;
		const { error, pageShouldBeVisible, isLoading } = vm;
		const elementsShouldEnter = transitionState === 'entered';

		return (
			<div className={getPageClasses(pageShouldBeVisible, isLoading)} data-pp-at-target={pageShouldBeVisible ? `Error page` : null}>
				<div className="panel-body panel-body-form" ref={this.savePanelBodyNode}>
					<PanelContentTransition in={elementsShouldEnter} setContentHeight={this.setContentHeight} className="panel-body-content">
						<ErrorMessage error={error} onResetPage={this.handleResetPage} />
					</PanelContentTransition>
				</div>
			</div>
		);
	}

	setContentHeight = (offsetHeight: number) => {
		if (this.panelBodyNode) {
			this.panelBodyNode.style.minHeight = `${offsetHeight}px`;
		}
	}

	private savePanelBodyNode = (panelBodyNode: HTMLDivElement) => this.panelBodyNode = panelBodyNode;

	private handleResetPage = (reason?: ResetPageReason) => {
		this.props.raiseAction(new PayerOnboardingUserAction.ResetPageBecauseOfError(reason));
	}
}
